import { faCheck, faCoins, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import SupplierPaymentApi from '../../../../Api/SupplierPaymentApi';
import { getResponseError } from '../../../../Api/Utils/apiUtils';
import ErrorAlert from '../../../Form/ErrorAlert/ErrorAlert';
import './PaymentSelect.css'

const PaymentSelect = ({iD, setCancel, isCard, setisCard, isPayId, setisPayId, setisreadyForPayment, expandDetails}) => {
    const [paymentMethod, setpaymentMethod] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null);


    function cardHandle() {
        setisCard(true)
        setisPayId(false)
    }
    function payIDHandle() {
        setisCard(false)
        setisPayId(true)
    }

    function removeErrorMessage() {
        setTimeout(() => {
            setErrorMessage(null)
        }, 5000);
    }

    function setupForPayment() {
        setisreadyForPayment(true)
        setCancel({id: expandDetails.id, expand: false, supplierId: expandDetails.supplierId, amount: expandDetails.amount, businessId: expandDetails.businessId, purchaseId: expandDetails.purchaseId, paymentId: expandDetails.paymentId, buyerId: expandDetails.paymentId})
    }

    useEffect(() => {
        const loadPaymentMethod = async () => {
            const response = await SupplierPaymentApi.getPaymentMethod(iD)
            const responseApiError = getResponseError(response)
            if (responseApiError) {
                setErrorMessage(responseApiError)
                removeErrorMessage()
            }else{
                const methodInfo = response.objectVal
                setpaymentMethod(methodInfo)
            }
        }
        loadPaymentMethod()
    }, [iD])

    return(
        <div className="payment-select">
            <ErrorAlert>{errorMessage}</ErrorAlert>
            {paymentMethod && 
            <div className="popup">
                {paymentMethod.isEFT &&
                <div className="credit-card" onClick={cardHandle}>
                    <h2><FontAwesomeIcon icon={faCreditCard} /> EFT Account</h2>
                    <div className="checkbox" style={isCard ? {backgroundColor: "#2442CE"}:{}}>
                        {isCard && 
                        <FontAwesomeIcon icon={faCheck} />}
                    </div>
                </div>}
                {paymentMethod.isPayId &&
                <div className="pay-id" onClick={payIDHandle}>
                    <h2><FontAwesomeIcon icon={faCoins} /> Pay ID</h2>
                    <div className="checkbox" style={isPayId ? {backgroundColor: "#2442CE"}:{}}>
                        {isPayId&&
                        <FontAwesomeIcon icon={faCheck} />}
                    </div>
                </div>}
                <div className="button-group">
                    <button onClick={() => setCancel({id: null, expand: false, supplierId: null, amount: null, businessId: null, purchaseId: null, paymentId: null, buyerId: null})} className="cancle">Cancel</button>
                    <button onClick={setupForPayment} className="next">Next</button>
                </div>
            </div>}
        </div>
    )
};

export default PaymentSelect;
